// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__-TSyo","ranges":"BmiRanges_ranges__3bYW9"};